import { ActionType } from 'deox';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest, select, delay } from 'redux-saga/effects';

import { Subscription } from 'services/api';

import {
  buySubscription,
  updateSubscription,
  deleteSubscription,
  showCancelPopup,
  // startSubscription,
} from './actions';
import { processRequestError } from 'modules/error/actions';
import { RootState } from 'types';
import { setNotification } from 'modules/app/actions';

import texts from './texts';
import { t } from 'utils';
import { getDashboardInfo } from 'modules/dashboard/actions';

function* buySubscriptionSaga({
  payload,
}: ActionType<typeof buySubscription.request>): SagaIterator {
  try {
    const { currencyType } = yield select((state: RootState) => state.user);
    const { registerData, temporary } = yield select((state: RootState) => state.auth);
    const body: any = {};

    body.currency = currencyType;

    body.number_of_machines = registerData.currentStripePrice.number_of_machines;
    body.billing_type = registerData.currentStripePrice.billing_type;
    body.payment_method = payload;
    body.temporary = temporary;
    yield call(Subscription.buySubscription, body);
    // @ts-ignore
    yield put(setNotification(true, t(texts.plan.successfullyUpdated)));
    yield put(buySubscription.success());
  } catch (error) {
    yield put(processRequestError({ error, failAction: buySubscription.fail }));
  }
}

function* updateSubscriptionSaga({
  payload,
}: ActionType<typeof updateSubscription.request>): SagaIterator {
  try {
    const { currencyType } = yield select((state: RootState) => state.user);
    const { registerData, temporary } = yield select((state: RootState) => state.auth);
    const body: any = {};

    body.currency = currencyType;

    body.number_of_machines = registerData.currentStripePrice.number_of_machines;
    body.billing_type = registerData.currentStripePrice.billing_type;
    if (payload) {
      body.payment_method = payload;
    }
    body.temporary = temporary;
    yield call(Subscription.updateSubscription, body);
    // @ts-ignore
    yield put(setNotification(true, t(texts.plan.successfullyUpdated)));
    yield delay(1000);
    yield put(updateSubscription.success());
    // yield put(getDashboardInfo.request());
  } catch (error) {
    yield put(processRequestError({ error, failAction: updateSubscription.fail }));
  }
}

function* deleteSubscriptionSaga() {
  try {
    yield call(Subscription.deleteSubscription);
    // @ts-ignore
    yield put(setNotification(true, t(texts.plan.successfullyUpdated)));
    yield put(deleteSubscription.success());
    yield put(showCancelPopup(false));
    window.location.href = '/dashboard';
    yield put(getDashboardInfo.request());
  } catch (error) {
    yield put(processRequestError({ error, failAction: deleteSubscription.fail }));
  }
}

// function* startSubscriptionSaga() {
//   try {
//     const { data } = yield call(Subscription.startSubscription);
//     // yield put(setNotification(true));
//     // yield put(startSubscription.success());
//   } catch (error) {
//     yield put(processRequestError({ error, failAction: startSubscription.fail }));
//   }
// }

export function* watchSubscription(): SagaIterator {
  yield takeLatest(buySubscription.request, buySubscriptionSaga);
  yield takeLatest(updateSubscription.request, updateSubscriptionSaga);
  yield takeLatest(deleteSubscription.request, deleteSubscriptionSaga);
  // yield takeLatest(startSubscription.request, startSubscriptionSaga);
}
